import { required, maxLength } from 'vuelidate/lib/validators'

const regexOperadores = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return !/^todos operadores+$/i.test(value)
}

const regexRamais = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return !/^todos ramais+$/i.test(value)
}

export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30), regexOperadores, regexRamais },
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Descrição é obrigatória.')
    !this.$v.form.description.maxLength && errors.push('Descrição não pode conter mais de 30 caracteres.')
    !this.$v.form.description.regexOperadores && errors.push('Nome não pode ser todos operadores')
    !this.$v.form.description.regexRamais && errors.push('Nome não pode ser todos ramais')
    return errors
  },
}
